import { render, staticRenderFns } from "./ComicBoxesOrder.vue?vue&type=template&id=6591a5fc&"
import script from "./ComicBoxesOrder.vue?vue&type=script&lang=js&"
export * from "./ComicBoxesOrder.vue?vue&type=script&lang=js&"
import style0 from "./ComicBoxesOrder.vue?vue&type=style&index=0&id=6591a5fc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports